import { ReactNode } from 'react';
import { AnyAction } from 'redux';

export interface SettingsState {
  readonly snackbar: {
    message: ReactNode;
    severity: Severity;
    timestamp: Date; // used to create unique object with each change
  };
}

const SET_SNACKBAR_MESSAGE = 'SET_SNACKBAR_MESSAGE';

export interface SetSnackbarMessageAction {
  type: 'SET_SNACKBAR_MESSAGE';
  message: ReactNode;
  severity?: Severity;
}

export type SettingsAction = SetSnackbarMessageAction;

export type Severity = 'success' | 'error' | 'warning' | 'info';

export const setSnackbarMessage = (message: ReactNode, severity?: Severity): SetSnackbarMessageAction => ({
  type: SET_SNACKBAR_MESSAGE,
  message,
  severity
});

const initialState = {
  snackbar: {
    message: null,
    severity: 'info',
    timestamp: Number(new Date())
  }
};

const settingsReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case SET_SNACKBAR_MESSAGE: {
      return {
        ...state,
        snackbar: {
          message: action.message,
          severity: action.severity || 'info',
          timestamp: Number(new Date())
        }
      };
    }
    default:
      return state;
  }
};

export default settingsReducer;
